export const instaCollectTooltip = {
  captureFlowTooltip:
    "Payments made by customers will be auto refunded to the source account if not captured within the specified time.",
  autoCaptureTooltip:
    "If enabled, transactions will be automatically captured based on the response received (status code 200) on webhook within Auto Capture TAT.",
  manualCaptureTooltip:
    "If enabled, transactions can be captured by Transaction Capture API or from the Capture button on the dashboard after the Auto Capture TAT is over.",
  autoCaptureTAT:
    "The time-frame after which transactions must be manually captured until auto-refunded.",
  footNote:
    "All changes will be applicable only for payments made after saving. All previous transactions will follow the timeframes as was defined when the payment was made.",
};

export const maxVals = {
  minutes: 60,
  hours: 24,
};

export const minutesInUnit = {
  days: 1440,
  hours: 60,
  minutes: 1,
};
